enum genCodeErrorEnum {
  MINUTE_LIMIT = "Time from the last attempt isn't out",
  HOURE_LIMIT = 'Too many requests for the same contact',
  DAY_LIMIT = 'Too many requests from the same browser',
}

const ATTEMPTS_WORD_FORM = ['попытка', 'попытки', 'попыток']
export { genCodeErrorEnum, ATTEMPTS_WORD_FORM }
